import { TaxDeduction } from '@/staff/domain/exclusive/TaxDeduction';

export interface BackendTaxDeductionToCreate {
  nonDeductibleAmountValue?: number;
}

export const fromTaxDeductionToCreate = (taxDeduction: TaxDeduction): BackendTaxDeductionToCreate => ({
  nonDeductibleAmountValue: taxDeduction.nonDeductibleAmount.value,
});
